import { useProductContext } from '../../common/hooks/useProductContext';

export const useFixedMoneyDecimals = () => {
    const { isFuel } = useProductContext();

    return (number: number) => {
        return number.toFixed(isFuel ? 2 : 4);
    };
};
